import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { PurchaseOrdersPage } from '@/components/PurchaseOrders/PurchaseOrdersPage'
import {
  purchaseOrderSearchSchema,
  withoutSearchDefaults,
} from '@/components/PurchaseOrders/search'
import { inPageSearch } from '@/lib/searchNavigation'

/**
 * Wiring only.
 *
 * The search schema and the default-pruning live beside the page, so imports
 * point one way (`components → routes`) and this file holds no logic to leave
 * untested.
 */
export const Route = createFileRoute('/_app/operations/purchase-orders/')({
  validateSearch: purchaseOrderSearchSchema,
  component: PurchaseOrdersRoute,
})

function PurchaseOrdersRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <PurchaseOrdersPage
      search={search}
      // Filtering and paging replace; opening a record is going somewhere, so
      // it pushes and the back button closes it. Either way the scroll stays.
      onSearchChange={(next, options) =>
        void navigate(inPageSearch(withoutSearchDefaults, next, options))
      }
    />
  )
}
